module.exports = __webpack_public_path__ + "static/desktop/img/bh-one.833a5ef3.jpg";